import { FC, Fragment } from 'react';
import {
  AddButton,
  RefreshButton,
  ResetButton,
  Searchbox,
  Toolbar,
} from '@bom-nextgen-keycloak/web/shared/ui';
import { useRole2 } from './hooks';
import {
  RoleDeleteDialog as DeleteDialog,
  RoleFormDialog as CreateDialog,
} from './components';
import { RoleTable2 } from './components/RoleTable2';

const Role2: FC = () => {
  const {
    canAdd,
    canDelete,
    canEdit,
    data,
    handleCreateAction,
    handleCreateCancel,
    handleCreateRequest,
    handleDeleteAction,
    handleDeleteCancel,
    handleDeleteRequest,
    handlePageChange,
    handleRefresh,
    handleSearchChange,
    handleSearchClear,
    handleSearchEnter,
    handleSearchReset,
    handleStepChange,
    isCreateDialogOpen,
    isDeleteDialogOpen,
    isDeleting,
    isFetched,
    isFetching,
    isLoading,
    isProcessing,
    isSearch,
    isSearching,
    paginationOffset: currentOffset,
    paginationStep: pageStep,
    searchQuery,
    selectedItem,
    wasSearch,
  } = useRole2();
  const showAddButton = canAdd;

  return (
    <Fragment>
      <Toolbar>
        <Toolbar.Control>
          <Toolbar.Search>
            <Searchbox
              autoFocus
              onChange={handleSearchChange}
              onClear={handleSearchClear}
              onEnter={handleSearchEnter}
              placeholder="Search by name"
              value={searchQuery}
            />
            <ResetButton disabled={!isSearch} onClick={handleSearchReset}>
              Reset Search
            </ResetButton>
          </Toolbar.Search>
          <Toolbar.Action>
            <RefreshButton onClick={handleRefresh}>Refresh</RefreshButton>
            {showAddButton && (
              <AddButton onClick={handleCreateRequest}>Add Role</AddButton>
            )}
          </Toolbar.Action>
        </Toolbar.Control>
      </Toolbar>
      <RoleTable2
        canDelete={canDelete}
        canEdit={canEdit}
        data={data.items}
        isFetched={isFetched}
        isFetching={isFetching}
        isLoading={isLoading}
        isProcessing={isProcessing}
        isSearch={isSearch}
        isSearching={isSearching}
        onDelete={handleDeleteRequest}
        onPageChange={handlePageChange}
        onStepChange={handleStepChange}
        paginationOffset={currentOffset}
        paginationStep={pageStep}
        totalCount={data.totalCount}
        totalRecord={data.totalRecord}
        wasSearch={wasSearch}
      />
      <CreateDialog
        onClose={handleCreateCancel}
        onSave={handleCreateAction}
        open={isCreateDialogOpen}
      />
      <DeleteDialog
        loading={isDeleting}
        name={selectedItem}
        onClose={handleDeleteCancel}
        onSubmit={handleDeleteAction}
        open={isDeleteDialogOpen}
      />
    </Fragment>
  );
};

export { Role2 };
